import { render, staticRenderFns } from "./MealConsumptionReport.vue?vue&type=template&id=6bb1b722"
import script from "./MealConsumptionReport.vue?vue&type=script&lang=js"
export * from "./MealConsumptionReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports